import getUrlParameter from 'Helpers/Url/GetUrlParameter';

/**
 * Get the sign up context for registration based on URL parameters
 * @return {String}
 */

export const getRegistrationSignUpContext = () => {
  const utmCampaign = getUrlParameter('utm_campaign');
  let signUpContext = 'New Account';
  // If coming from Fandom Journey campaign, set context to 'fandomuser' which will trigger specific welcome emails
  if (utmCampaign && utmCampaign.includes('FandomJourney')) signUpContext = 'fandomuser';

  return signUpContext;
};

export default getRegistrationSignUpContext;
